/*jshint esversion: 6 */
export class Group {
   constructor(name, isAdmin, policies) {
      // this._id = '';
      // this.ownerPaid = '';
      this.name = name || '';
      this.isAdmin = isAdmin || false;
      this.policies = policies || [];
   }
}